import React from "react";
import { Box, Container, Hidden } from "@mui/material";
import { NavbarStyle } from "./style";
import { TopNavBar } from '../components';
import {
  useGetAllAssetsMutation,
  useListingAgentGetMutation,
} from "../redux/services";
import { LocalStorageKeys } from "../utils";
import { config } from "../config";

const withNavBars = (Component, params) => (props) => {
  const [assetApiCall] = useGetAllAssetsMutation()
  const client = localStorage.getItem(LocalStorageKeys.client)
  const [data, setData] = React.useState()
  const [agentToken, setAgentToken] = React.useState("");
  const hostName = window.location.origin;

  const [listingAgentGet] = useListingAgentGetMutation();

  React.useEffect(() => {
    getToken();
  }, []);

  React.useEffect(() => {
    if (!agentToken) return;
    if (document.getElementById("chat-widget-script")) return;
    const script = document.createElement("script");
    script.src = `${config.agent_widget_url}?token=${agentToken}`;
    script.async = true;
    script.id = "chat-widget-script";
    document.body.appendChild(script);
    return () => {
      document.getElementById("chat-widget-script")?.remove();
    };
  }, [agentToken]);

  const getToken = () => {
    listingAgentGet({
      client_url: client,
    })
      .then((res) => {
        setAgentToken(res?.data?.response?.data?.agent_token);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getAssetsAndLinks = (pathName) => {
    const payload = {
      client_url: pathName
    }
    assetApiCall(payload)
      .then((response) => {
        setData(response?.data?.response)
      }).catch((error) => {
        console.log(error);
      })

  }
  let host_arr = [config?.listings_url , config?.realitygoto_url ,config?.amenitiesgoto_url]
  React.useEffect(() => {
    if (client?.length > 0 || !(host_arr?.includes(hostName)) ) {
      getAssetsAndLinks(client)
    }
    // eslint-disable-next-line
  }, [])

  return (
    <Box sx={NavbarStyle.root} >
      {/* Your nav bars here */}
      <Container sx={{ maxWidth: "1920px !important", padding: "0px !important" }}>
        <Box sx={NavbarStyle.topNavbar}>
          <Hidden smDown>
            <TopNavBar {...params} tab={params?.key} assetsAndLinks={data} />
          </Hidden>
          {
            window.location.pathname === '/residentview' || window.location.pathname === '/commercialview' ?
              < Hidden smDown>
                <TopNavBar {...params} tab={params?.key} assetsAndLinks={data} />
              </Hidden>
              :
              <TopNavBar {...params} tab={params?.key} assetsAndLinks={data} />

          }

        </Box>

        {/* Content */}
        <Box sx={window.location.pathname === '/residentview' || window.location.pathname === '/commercialview' ? NavbarStyle.resContent : NavbarStyle.content} >
          <Component {...params} assetsAndLinks={data}>{props.children}</Component>
        </Box>


      </Container >
    </Box >
  );
};

export default withNavBars;
